import { t } from "@web-monorepo/i18n/macro";
import FullScreenCardPage from "./FullScreenCardPage";
import SlideNavigation from "./SlideNavigation";
import type { RemoteSlideProps, Slide } from "./types";
import { resolveText, type SlideText } from "./text";
import styles from "./DescriptionSlide.module.css";

export const DescriptionSlide = (text?: SlideText, img?: string, sentenceStarter?: SlideText): Slide => {
  return {
    remote: ({ next }: RemoteSlideProps) => (
      <div className={styles.frame}>
        <div className={styles.card}>
          {text && <div className={styles.description}>{resolveText(text)}</div>}
          {img && <img src={img} className={text == null ? styles.fullImage : styles.image} alt={t`Mojo`} />}
        </div>
        <SlideNavigation onBack={() => next(-1)} onNext={() => next()} />
      </div>
    ),
    display: () => (
      <FullScreenCardPage>
        <div className={styles.displayCard}>
          {text && <div className={styles.displayDescription}>{resolveText(text)}</div>}
          {sentenceStarter && <div className={styles.displaySentenceStarter}>{resolveText(sentenceStarter)}</div>}
          {img && (
            <img src={img} className={text == null ? styles.displayFullImage : styles.displayImage} alt={t`Mojo`} />
          )}
        </div>
      </FullScreenCardPage>
    ),
  };
};
